// extracted by mini-css-extract-plugin
module.exports = {"container":"CardAppList_container__3YjLC","cardApp":"CardAppList_cardApp__Mmai_"};